const INVITED_APPLICANT_OVERALL_STATUS = Object.freeze({
  PERSON_INFO_INVITE_SENT: 'PERSON_INFO_INVITE_SENT',
  PERSON_INFO_IN_PROGRESS: 'PERSON_INFO_IN_PROGRESS',
  VERIFICATION_IN_PROGRESS: 'VERIFICATION_IN_PROGRESS',
  VERIFICATION_REJECTED: 'VERIFICATION_REJECTED',
  VERIFICATION_PENDING_REVIEW: 'VERIFICATION_PENDING_REVIEW',
  VERIFICATION_COMPLETE: 'VERIFICATION_COMPLETE',
  DISCLOSURES_CONTINUATION_EMAIL_SENT: 'DISCLOSURES_CONTINUATION_EMAIL_SENT',
  DISCLOSURES_IN_PROGRESS: 'DISCLOSURES_IN_PROGRESS',
  DISCLOSURES_COMPLETE: 'DISCLOSURES_COMPLETE'
});

export default INVITED_APPLICANT_OVERALL_STATUS;